//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import htmlToText from 'html-to-text'
import { truncate } from 'lodash'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'ClientTasksListItem',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    createdDate () {
      return this.$moment(this.task.createdAt)
        .fromNow()
    },
    partialDescription () {
      const stripped = htmlToText.fromString(this.task.description, {
        wordwrap: 300
      })

      return truncate(stripped, {
        length: 300,
        separator: ' '
      })
    }
  }
}
